/**
 * Delay before auto-marking opened notifications as read.
 * Keeping a short delay preserves a brief "new" affordance, mirroring common
 * social activity feed behavior.
 */
export const NOTIFICATIONS_AUTO_MARK_READ_DELAY_MS = 1500;

